import { Divider, Stack, Typography } from "@mui/material";
import ExamResultsTemplateButton from "./ExamResultsTemplateButton";

const ExamStatusSymbols = () => {
  return (
    <>
      <Typography
        color={"secondary"}
        sx={{ textAlign: "center", fontWeight: "bold" }}
      >
        Символи за статус на изпит
      </Typography>
      <Stack
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        spacing={2}
      >
        <Typography sx={{ fontStyle: "italic" }}>Неявил се: ?</Typography>
        <Divider
          orientation="vertical"
          flexItem
        />
        {/* <Typography sx={{fontStyle: "italic"}}>Не полага: -</Typography> */}
        <Typography sx={{ fontStyle: "italic" }}>Отстранен: -</Typography>
        <Divider
          orientation="vertical"
          flexItem
        />
        <ExamResultsTemplateButton />
      </Stack>
    </>
  );
};

export default ExamStatusSymbols;
